"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var core_2 = require('@angular/core');
var interfaces_1 = require('./interfaces');
var font_picker_component_1 = require('./font-picker.component');
var FontPickerDirective = (function () {
    function FontPickerDirective(resolver, el, vc) {
        this.resolver = resolver;
        this.el = el;
        this.vc = vc;
        this.fpWidth = '280px';
        this.fpHeight = '320px';
        this.fpFallbackFont = new interfaces_1.Font({
            family: 'Roboto',
            size: '16px',
            style: 'regular',
            styles: ['regular']
        });
        this.fpSizeSelect = true;
        this.fpStyleSelect = true;
        this.fpPosition = 'bottom';
        this.fpPositionOffset = '0%';
        this.fpPositionRelativeToArrow = false;
        this.fpCancelButton = false;
        this.fpCancelButtonText = 'Cancel';
        this.fpCancelButtonClass = 'fp-cancel-button-class';
        this.fpUploadButton = false;
        this.fpUploadButtonText = 'Upload';
        this.fpUploadButtonClass = 'fp-upload-button-class';
        this.fontPickerChange = new core_1.EventEmitter();
    }
    FontPickerDirective.prototype.ngOnInit = function () {
        var fontPicker = this.fontPicker;
        if (!this.fontPicker) {
            this.fontPicker = this.fpFallbackFont;
        }
        if (fontPicker != this.fontPicker) {
            this.fontPickerChange.emit(this.fontPicker);
        }
    };
    FontPickerDirective.prototype.onClick = function () {
        if (!this.dialog) {
            var compFactory = this.resolver.resolveComponentFactory(font_picker_component_1.FontPickerComponent);
            var injector = core_2.ReflectiveInjector.fromResolvedProviders([], this.vc.parentInjector);
            this.dialog = this.vc.createComponent(compFactory, 0, injector, []).instance;
            this.dialog.setDialog(this, this.el, this.fontPicker, this.fpPosition, this.fpPositionOffset, this.fpPositionRelativeToArrow, this.fpPresetLabel, this.fpPresetFonts, this.fpUploadButton, this.fpUploadButtonClass, this.fpUploadButtonText, this.fpStyleSelect, this.fpSizeSelect, this.fpCancelButton, this.fpCancelButtonClass, this.fpCancelButtonText, this.fpHeight, this.fpWidth);
        }
        else if (!this.dialog.open) {
            this.dialog.updateDialog(this.fontPicker, this.fpPosition, this.fpPositionOffset, this.fpPositionRelativeToArrow, this.fpPresetLabel, this.fpPresetFonts, this.fpUploadButton, this.fpUploadButtonClass, this.fpUploadButtonText, this.fpStyleSelect, this.fpSizeSelect, this.fpCancelButton, this.fpCancelButtonClass, this.fpCancelButtonText, this.fpHeight, this.fpWidth);
            this.dialog.openFontPicker();
        }
        else {
            this.dialog.closeFontPicker();
        }
    };
    FontPickerDirective.prototype.fontChanged = function (value) {
        this.fontPickerChange.emit(value);
    };
    __decorate([
        core_1.Input('fontPicker'), 
        __metadata('design:type', (typeof (_a = typeof interfaces_1.Font !== 'undefined' && interfaces_1.Font) === 'function' && _a) || Object)
    ], FontPickerDirective.prototype, "fontPicker", void 0);
    __decorate([
        core_1.Input('fpWidth'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpWidth", void 0);
    __decorate([
        core_1.Input('fpHeight'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpHeight", void 0);
    __decorate([
        core_1.Input('fpFallbackFont'), 
        __metadata('design:type', (typeof (_b = typeof interfaces_1.Font !== 'undefined' && interfaces_1.Font) === 'function' && _b) || Object)
    ], FontPickerDirective.prototype, "fpFallbackFont", void 0);
    __decorate([
        core_1.Input('fpPresetLabel'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpPresetLabel", void 0);
    __decorate([
        core_1.Input('fpPresetFonts'), 
        __metadata('design:type', Object)
    ], FontPickerDirective.prototype, "fpPresetFonts", void 0);
    __decorate([
        core_1.Input('fpSizeSelect'), 
        __metadata('design:type', Boolean)
    ], FontPickerDirective.prototype, "fpSizeSelect", void 0);
    __decorate([
        core_1.Input('fpStyleSelect'), 
        __metadata('design:type', Boolean)
    ], FontPickerDirective.prototype, "fpStyleSelect", void 0);
    __decorate([
        core_1.Input('fpPosition'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpPosition", void 0);
    __decorate([
        core_1.Input('fpPositionOffset'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpPositionOffset", void 0);
    __decorate([
        core_1.Input('fpPositionRelativeToArrow'), 
        __metadata('design:type', Boolean)
    ], FontPickerDirective.prototype, "fpPositionRelativeToArrow", void 0);
    __decorate([
        core_1.Input('fpCancelButton'), 
        __metadata('design:type', Boolean)
    ], FontPickerDirective.prototype, "fpCancelButton", void 0);
    __decorate([
        core_1.Input('fpCancelButtonText'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpCancelButtonText", void 0);
    __decorate([
        core_1.Input('fpCancelButtonClass'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpCancelButtonClass", void 0);
    __decorate([
        core_1.Input('fpUploadButton'), 
        __metadata('design:type', Boolean)
    ], FontPickerDirective.prototype, "fpUploadButton", void 0);
    __decorate([
        core_1.Input('fpUploadButtonText'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpUploadButtonText", void 0);
    __decorate([
        core_1.Input('fpUploadButtonClass'), 
        __metadata('design:type', String)
    ], FontPickerDirective.prototype, "fpUploadButtonClass", void 0);
    __decorate([
        core_1.Output('fontPickerChange'), 
        __metadata('design:type', Object)
    ], FontPickerDirective.prototype, "fontPickerChange", void 0);
    FontPickerDirective = __decorate([
        core_1.Directive({
            selector: '[fontPicker]',
            host: {
                '(click)': 'onClick()'
            }
        }), 
        __metadata('design:paramtypes', [(typeof (_c = typeof core_2.ComponentFactoryResolver !== 'undefined' && core_2.ComponentFactoryResolver) === 'function' && _c) || Object, (typeof (_d = typeof core_2.ElementRef !== 'undefined' && core_2.ElementRef) === 'function' && _d) || Object, (typeof (_e = typeof core_2.ViewContainerRef !== 'undefined' && core_2.ViewContainerRef) === 'function' && _e) || Object])
    ], FontPickerDirective);
    return FontPickerDirective;
    var _a, _b, _c, _d, _e;
}());
exports.FontPickerDirective = FontPickerDirective;



//////////////////
// WEBPACK FOOTER
// ./src/lib/font-picker.directive.ts
// module id = 15
// module chunks = 0 1